// Success / confirmation screen — RON-5466 Phase 2, reused throughout Phase 3.
//
// Deliberately generic: "Visitor invited", "Changes saved" and "Bookings cancelled" are all this
// component with different keys and, for the last, `variant="cancel"`.

import { useTranslation } from "react-i18next";

const VisitorConfirmation = ({
  titleKey,
  messageKey,
  // Substituted into `%s` in the message. The app interpolates with `.replace("%s", …)` rather
  // than i18next interpolation, so this follows that convention.
  messageValue,
  // Plain text under the title — an email address, not a translated key. Optional, and omitted
  // entirely when empty so the flex gap does not leave a hole where a line should be.
  subtitle,
  // Rows the action could NOT apply to — a bulk cancel's skipped visits (§9a `results`).
  // `{ id, name, message }`. Empty for every other use, which is why nothing else passes it.
  rows = [],
  rowsLabel,
  variant = "success",
  onBack,
}) => {
  const { t } = useTranslation("common");

  const message =
    messageValue === undefined
      ? t(messageKey)
      : t(messageKey).replace("%s", messageValue);

  return (
    <div className={`visitor-confirmation visitor-confirmation--${variant}`}>
      {/* A tick for every variant, including cancel. A cancellation that worked IS a success; the
          red tint on the disc already carries "that was destructive". An exclamation mark here read
          as though something had gone wrong. */}
      <span className="visitor-confirmation__mark" aria-hidden="true">
        ✓
      </span>
      <p className="visitor-confirmation__title">{t(titleKey)}</p>
      {subtitle && <p className="visitor-confirmation__subtitle">{subtitle}</p>}
      <p className="visitor-confirmation__message">{message}</p>

      {/* NAMED, not counted. "1 could not be cancelled" leaves the host to work out which one
          of the hundred rows they ticked it was; the server told us, so we say. */}
      {rows.length > 0 && (
        <div className="visitor-confirmation__kept">
          {rowsLabel && (
            <p className="visitor-confirmation__kept-label">{rowsLabel}</p>
          )}
          <ul>
            {rows.map((row) => (
              <li className="visitor-confirmation__kept-row" key={row.id}>
                <span className="visitor-confirmation__kept-name">{row.name}</span>
                {row.message && (
                  <span className="visitor-confirmation__kept-why">{row.message}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
      <button
        type="button"
        className="visitor-btn visitor-btn--secondary"
        onClick={onBack}
      >
        {t("react_visitors_back_to_list")}
      </button>
    </div>
  );
};

export default VisitorConfirmation;
